import Call from '../../Call';

const DefaultOffers = {
    get() {
        return Call(`adkBanner/defaultOffers`);
    },

    getMeta() {
        return Call(`adkBanner/defaultOffers/meta`);
    },

    save(offer) {
        return Call('adkBanner/defaultOffers','POST', offer);
    },

    update(id, offer) {
        return Call(`adkBanner/defaultOffers/${id}`,'PUT', offer);
    },

    remove(id) {
        return Call(`adkBanner/defaultOffers/${id}`,'DELETE');
    },
};

export default DefaultOffers;


// WEBPACK FOOTER //
// ./src/services/API/components/AdkBanner/DefaultOffers.js